import React from "react";
import { connect } from 'react-redux'
import { compose } from 'redux'
import {
  Switch,
  Route,
  withRouter,
  Redirect
} from "react-router-dom"

import Login from './containers/Login'
import Dashboard from './containers/Dashboard'

import { getItem } from './utils/tokenStore'

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (
    !true
      ? <Redirect to='/login' />
      : <Component {...props} />
  )} />
);

function CustomRouter({ location, ... props }) {

  return (
    <Switch>
      <Route exact path="/login" component={ Login } initialPath />
      <PrivateRoute path="/dashboard" component={ Dashboard } />
      <Redirect from={ '/' } to={ '/login' } />
    </Switch>
  );
}

const mapStateToProps = state => ({ data: state })
export default compose(
  connect( mapStateToProps ),
  withRouter
)( CustomRouter )